//--------------------------------------------------
// 直播场景
//--------------------------------------------------
const Common = require('@/tbs/model/to/Common')
const ClassFunc = require('@/tbs/util/ClassFunc')

const tbs_model_to_Live = function () {
  ClassFunc.super(this, Common, arguments)
}

tbs_model_to_Live.prototype = {
  'live-status-label-0': '即将直播',
  'live-status-label-1': '直播中',
  'live-status-label-2': '录像',
}

ClassFunc.extend(tbs_model_to_Live, Common)

module.exports = tbs_model_to_Live
